import React from 'react';
import PropTypes from 'prop-types';
import { classes, WoodCutOptimizerButtonStyles } from './WoodCutOptimizerButton.style';
import Tooltip from './Tooltip/Tooltip';
import Modal from './Modal/Modal';
import MobileFullscreenModal from './MobileFullscreenModal/MobileFullscreenModal';
import useWoodCutOptimizer from './useWoodCutOptimizer';
import { withProduct } from '../../utils/ProductContext';
import { withApplicationContext } from '../../utils/ApplicationContext';

const WoodCutOptimizerButton = ({ handleAddToCart, product, appCtx }) => {
  const {
    isTooltipVisible,
    isModalOpen,
    buttonRef,
    tooltipRef,
    handleButtonClick,
    handleTooltipButtonClick,
    handleCloseModal,
    iframeSrcUrl,
    showButton,
    showCouchMark,
    handleCouchMarkClick,
    deviceType,
  } = useWoodCutOptimizer(handleAddToCart, product, appCtx);
  const isMobileOrTablet = ['mobile', 'tablet'].includes(deviceType);

  const renderIframe = () => (
    <iframe title="iframe" src={iframeSrcUrl} width="100%" height={isMobileOrTablet ? '100%' : '580px'} />
  );

  const renderModalContent = () => {
    if (!isModalOpen) {
      return null;
    }

    if (isMobileOrTablet) {
      return <MobileFullscreenModal onClose={handleCloseModal}>{renderIframe()}</MobileFullscreenModal>;
    }

    return <Modal onClose={handleCloseModal}>{renderIframe()}</Modal>;
  };

  if (!showButton) return null;

  return (
    <div className={classes.container}>
      {WoodCutOptimizerButtonStyles}
      <div className={classes.tooltipWrapper}>
        <button
          ref={buttonRef}
          type="button"
          className={`${classes.button}${isMobileOrTablet ? ' mobile' : ''}`}
          onClick={handleButtonClick}
          data-testid="wood-cut-button"
        >
          {showCouchMark && (
            <div
              className={`${classes.iconContainer}${isMobileOrTablet ? ' mobile' : ''}`}
              role="button"
              tabIndex={0}
              onClick={handleCouchMarkClick}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  handleCouchMarkClick(e);
                }
              }}
              data-testid="couch-mark-icon"
              aria-pressed="false"
            >
              <div className={classes.iconWrapper}>
                <span className={`${classes.pulseCircle} layer2`} />
                <span className={`${classes.pulseCircle} layer3`} />
                <span className={classes.icon} />
              </div>
            </div>
          )}
          <span className={classes.woodCutterIcon} />
          Dimensionar tablero
        </button>
        {showCouchMark && (
          <Tooltip
            ref={tooltipRef}
            isVisible={isTooltipVisible}
            title="Dimensiona sin costo"
            text="Ahora puedes retirar el producto ya cortado o descargar el plano y llevarlo a tienda para que lo realicen."
            buttonText="Entendido"
            onButtonClick={handleTooltipButtonClick}
            position={isMobileOrTablet ? 'top' : 'left'}
          />
        )}
      </div>
      {renderModalContent()}
    </div>
  );
};

WoodCutOptimizerButton.propTypes = {
  handleAddToCart: PropTypes.func.isRequired,
  product: PropTypes.object.isRequired,
  appCtx: PropTypes.object.isRequired,
};

export default withApplicationContext(withProduct(WoodCutOptimizerButton));
